import types from '@redux/types/basic/layout'

export const push = (list, key) => {
  return ({
    payload: {
      list,
      key
    },
    type: types.PUSH_CRUMB_LIST
  })
}

export const replace = (list, key) => ({
  payload: {
    list,
    key
  },
  type: types.REPLACE_CRUMB_LIST
})

export const reset = (list, key) => ({
  payload: {
    list,
    key
  },
  type: types.RESET_CRUMB_LIST
})

export const redo = (payload = 1) => ({
  payload,
  type: types.REDO_CRUMB_LIST
})

export const undo = (payload = 1) => ({
  payload,
  type: types.UNDO_CRUMB_LIST
})

export const init = payload => ({
  payload,
  type: types.INIT_CRUMB_LIST
})
